import { z } from 'zod';

export const customerFormSchema = z.object({
  firstName: z.string().trim().min(1, 'Vorname ist erforderlich').max(100),
  lastName: z.string().trim().min(1, 'Nachname ist erforderlich').max(100),
  email: z.string().trim().email('Gültige E-Mail-Adresse eingeben').max(255),
  phone: z.string().trim().max(40).optional().or(z.literal('')),
  street: z.string().trim().min(1, 'Strasse ist erforderlich').max(200),
  streetNumber: z.string().trim().min(1, 'Hausnummer ist erforderlich').max(20),
  postalCode: z.string().trim().min(1, 'PLZ ist erforderlich').max(20),
  city: z.string().trim().min(1, 'Ort ist erforderlich').max(100),
  country: z.string().trim().length(2, 'Land muss ein 2-stelliger Code sein'),
});

export type CustomerFormValues = z.infer<typeof customerFormSchema>;

export const customerFormDefaults: CustomerFormValues = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  street: '',
  streetNumber: '',
  postalCode: '',
  city: '',
  country: 'CH',
};
